import React from 'react';

// Loading states.
//
// Two different waits, deliberately shown differently:
//
//   Skeleton — the first load, where there is nothing on screen and the shape
//   of what is coming is useful information.
//   Fade — a tab switch, where the data is already in memory and the change is
//   instant. There is nothing to wait for, so this is only a transition; a
//   spinner here would invent a delay that does not exist.

export function Skeleton({ rows = 8 }) {
    return (
        <div className="skeleton" aria-hidden="true">
            <div className="skeleton__bar skeleton__bar--head" />
            {Array.from({ length: rows }, (_, i) => (
                <div key={i} className="skeleton__bar" style={{ width: `${92 - (i % 4) * 11}%` }} />
            ))}
        </div>
    );
}

/** Re-runs its entrance animation whenever `viewKey` changes. */
export function FadeIn({ viewKey, children }) {
    return (
        <div key={viewKey} className="fadein">
            {children}
        </div>
    );
}
